/** a very simple way of displaying an image within a modal **/
window.RosenheimJetztOpenStreetMarkerImagePreview = function (image) {
	var showCssClassName = 'show-modal'
	var modal = document.querySelector('.js-marker-modal__modal')

	// only when modal and image is present
	if (modal && image) {
		// clone image to show at modal and remove click attribute
		var clonedImage = image.cloneNode()
		clonedImage.removeAttribute('onclick')

		// get container for image within modal
		var imageContainer = modal.querySelector('.js-marker-modal__image-container')

		// firstchild is present when the model image was set once
		if (imageContainer.firstChild) {
			imageContainer.replaceChild(clonedImage, imageContainer.firstChild)
		} else {
			// case for first time rendering
			imageContainer.appendChild(clonedImage)
			// also add event to toggle when click outside the modal image
			modal.addEventListener('click', (e) => {
				// if target is the image do nothing because user want to zoom or save
				if (e.target instanceof HTMLImageElement) {
					e.preventDefault()
				} else {
					modal.classList.remove(showCssClassName)
				}
			})
		}

		// always show modal when clicked on a preview image
		modal.classList.add(showCssClassName)
	}
}
